import { render, staticRenderFns } from "./WorkCard.vue?vue&type=template&id=0af59dd6&scoped=true&"
import script from "./WorkCard.vue?vue&type=script&lang=js&"
export * from "./WorkCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkCard.vue?vue&type=style&index=0&id=0af59dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af59dd6",
  null
  
)

export default component.exports